import { Badge } from 'slab'
import { type EmployersRenewalsEmployeeEnrollmentStatus as EnrollmentStatus } from 'utils/web_api.schemas'

import { enrollmentStatusDisplayValue } from './utils'

const getBadgeType = (enrollmentStatus: EnrollmentStatus) => {
  switch (enrollmentStatus) {
    case 'enrolled':
      return 'success'
    case 'declined':
      return 'critical'
    case 'not_invited':
      return 'warning'
    case 'not_accepted':
      return 'caution'
    case 'offboarded':
      return 'critical'
    default:
      return 'neutral'
  }
}

export default function EnrollmentStatusBadge ({ enrollmentStatus }: { enrollmentStatus: EnrollmentStatus }) {
  return (
    <Badge type={getBadgeType(enrollmentStatus)}>
      {enrollmentStatusDisplayValue(enrollmentStatus)}
    </Badge>
  )
}
